import { localParts } from '@siva/shared';
import { t } from '../i18n/index.js';

/** "Good Morning" / "Good Afternoon" / "Good Evening", by the office clock. */
export function greeting(): string {
  const h = localParts(new Date()).hour;
  return h < 12 ? t('greet_morning') : h < 17 ? t('greet_afternoon') : t('greet_evening');
}

/** The first name, which is how people are greeted here. */
export function firstName(name: string | null | undefined): string {
  return (name ?? '').trim().split(/\s+/)[0] ?? '';
}
